module.exports = __webpack_public_path__ + "static/media/img-slide-2.03a563f7.png";